import { render, staticRenderFns } from "./StatisticsCentreCancel.vue?vue&type=template&id=66caf7ac&scoped=true"
import script from "./StatisticsCentreCancel.vue?vue&type=script&lang=js"
export * from "./StatisticsCentreCancel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66caf7ac",
  null
  
)

export default component.exports